import React from 'lib/react';
import { EVButton, EVKeyboardArrowDown, EVKeyboardArrowUp } from 'lib/components';
import { useTranslation } from 'lib/translation';
import PropTypes from 'prop-types';
import OrderStyles from '../OrderStyles';

function ToggleMapButton(props) {
  const classes = OrderStyles();
  const { t } = useTranslation();
  const { handleClick, showMap } = props;

  return (
    <EVButton
      fullWidth
      onClick={handleClick}
      className={classes.toggleMapButton}
    >
      {
        showMap
          ? (
            <>
              {t('ChooseProducts')}
              <EVKeyboardArrowDown
                id="keyboardArrowDown"
                className={classes.toggleMapArrow}
              />
            </>
          )
          : (
            <>
              {t('ShowMap')}
              <EVKeyboardArrowUp
                className={classes.toggleMapArrow}
              />
            </>
          )
      }
    </EVButton>
  );
}

ToggleMapButton.propTypes = {
  handleClick: PropTypes.func.isRequired,
  showMap: PropTypes.bool.isRequired,
};

export default ToggleMapButton;
